// ABOUTME: Mide la silueta de cabeza+pelo sobre la máscara de categorías del segmentador
// ABOUTME: de selfie de MediaPipe (fila superior y anchura máxima hasta una fila de referencia).

/** Categorías del modelo selfie_multiclass_256x256. */
export const HEAD_CLASSES = { hair: 1, faceSkin: 3 } as const;

export interface SilhouetteOptions {
  /** Fila (px) hasta la que se busca la anchura máxima: nivel de los ojos/cejas. */
  referenceRow: number;
  /** Mínimo de píxeles seguidos para considerar que una fila tiene cabeza (filtra ruido). */
  minRun: number;
}

export interface SilhouettePx {
  topRow: number;
  leftCol: number;
  rightCol: number;
}

/**
 * Por encima de las cejas, cualquier píxel de persona cuenta como cabeza: así no dependemos
 * de que el segmentador etiquete bien pelo teñido, gorros, pañuelos o rastas ya puestas.
 */
function isHead(category: number): boolean {
  return category !== 0;
}

/** Devuelve [inicio, fin] de la racha más larga de píxeles de cabeza en la fila, o null. */
function longestRun(mask: Uint8Array, width: number, row: number): [number, number] | null {
  let best: [number, number] | null = null;
  let start = -1;
  for (let x = 0; x <= width; x++) {
    const head = x < width && isHead(mask[row * width + x]);
    if (head && start < 0) start = x;
    if (!head && start >= 0) {
      if (!best || x - start > best[1] - best[0] + 1) best = [start, x - 1];
      start = -1;
    }
  }
  return best;
}

export function measureSilhouette(
  mask: Uint8Array,
  width: number,
  height: number,
  options: SilhouetteOptions,
): SilhouettePx | null {
  const lastRow = Math.min(height - 1, Math.max(0, Math.round(options.referenceRow)));
  let topRow = -1;
  let leftCol = Number.POSITIVE_INFINITY;
  let rightCol = Number.NEGATIVE_INFINITY;
  for (let y = 0; y <= lastRow; y++) {
    const run = longestRun(mask, width, y);
    if (!run || run[1] - run[0] + 1 < options.minRun) continue;
    if (topRow < 0) topRow = y;
    leftCol = Math.min(leftCol, run[0]);
    rightCol = Math.max(rightCol, run[1]);
  }
  if (topRow < 0) return null;
  return { topRow, leftCol, rightCol };
}
